import { BaseController } from '../../../../../common/base/controller';
import { homeStateName } from '../../../../../components/home/home.state';
import { TicketStatesReceiving } from '../../../../ticket/ticket.constants';
import { Errors } from './submitRequest.constants';

import _ from 'lodash';

export class ReceivingSubmitRequestController extends BaseController {
  constructor(
    $rootScope,
    $scope,
    $http,
    $interval,
    controllerService,
    ticketService,
    ticketSidebarPartial,
    ticketClosePartial,
    fileResponseService,
    receivingService,
    fdFormFieldsService,
    TicketStates,
    ticketStateName,
    ticketReaderFactory,
    ReceivingCreatedSuccessState,
    ReceivingSubmitValidationRules,
    ReceivingKwhTypes,
    needsConfirmationService,
    submitRequestDownloadTemplate,
    submitRequestUploadTemplate,
    submitRequestSubmitTemplate,
    submitRequestFormButtonTemplate,
    submitRequestSetPasswordTemplate,
    submitRequestAdditionalDocumentsTemplate,
    submitSterbeurkundeDocumentsTemplate,

    //directBankTemplates
    submitRequestDownloadTemplateDirectBank,
    submitRequestNextStepsTemplateDirectBank,
    submitRequestFormButtonTemplateDirectBank,

    SubmitRequestInfoBoxItems,
    ValidationFormMessages,
    signoTecService,
    qrMismatchService,
  ) {
    'ngInject';
    super({
      $rootScope,
      $scope,
      $http,
      $interval,
      controllerService,
      ticketService,
      ticketSidebarPartial,
      ticketClosePartial,
      fileResponseService,
      receivingService,
      fdFormFieldsService,
      TicketStates,
      ticketReaderFactory,
      ticketStateName,
      ReceivingCreatedSuccessState,
      ReceivingSubmitValidationRules,
      ReceivingKwhTypes,
      needsConfirmationService,
      submitRequestDownloadTemplate,
      submitRequestUploadTemplate,
      submitRequestSubmitTemplate,
      submitRequestFormButtonTemplate,
      submitRequestSetPasswordTemplate,
      //directBankTemplates
      submitRequestDownloadTemplateDirectBank,
      submitRequestNextStepsTemplateDirectBank,
      submitRequestFormButtonTemplateDirectBank,

      submitRequestAdditionalDocumentsTemplate,
      submitSterbeurkundeDocumentsTemplate,
      SubmitRequestInfoBoxItems,
      ValidationFormMessages,
      signoTecService,
      qrMismatchService,
    });
  }

  get featureEnabledSignotecSignatureOrForceDefault() {
    if (this.envService.isDevelopment()) {
      // override for dev for testing purposes
      return !this.skipSignature;
    }

    return (
      this.isFeatureActive(this.FeatureNames.FF_ENABLE_SIGNOTEC_SIGNATURE) &&
      !this.forceDefaultWarrantFlow &&
      !this.skipSignature
    );
  }

  get skipWarrantShipmentToggleActive() {
    return this.isFeatureActive(this.FeatureNames.FF_SKIP_WARRANT_SHIPMENT);
  }

  get showDescription() {
    return !this.isDirectBank;
  }

  get isDirectBank() {
    return this.config.isDirectBank;
  }

  get showCheckboxForAcceptSignatureUsageForSEPA() {
    return (
      this.isFeatureActive(
        this.FeatureNames.FF_SHOW_CHECKBOX_FOR_ACCEPT_SIGNATURE_USAGE_FOR_SEPA,
      ) && !this.docImageUrl
    );
  }

  get downloadTemplate() {
    return this.isDirectBank
      ? this.submitRequestDownloadTemplateDirectBank
      : this.submitRequestDownloadTemplate;
  }

  get configSkipGuidanceRequest() {
    return this.getConfigItem(
      'ui.receivingRequest.submitForm.skipGuidanceRequest',
      false,
    );
  }

  get configSkipDownload() {
    return this.getConfigItem('ui.receivingRequest.submit.skipDownload', false);
  }

  get prefilledConsultantEmail() {
    return this.getConfigItem(
      'ui.receivingRequest.submit.prefilledConsultantMail',
      null,
    );
  }

  get featurePasswordInSubmit() {
    return this.isFeatureActive(
      this.FeatureNames.FF_SET_PACKAGE_PASSWORD_IN_SUBMIT_WARRANT_STATE,
    );
  }

  get isUploadAdditionalSectionVisible() {
    return (
      (this.isUploadSectionVisible || this.docImageUrl) &&
      !this.userService.isCustomerEntryUser()
    );
  }

  get isSterbeurkundeUploadSectionVisible() {
    return this.isNachlass && (this.isUploadSectionVisible || this.docImageUrl);
  }

  uploadSterbeurkunde() {
    if (!this.isNachlass || _.isEmpty(this.sterbeurkundeFiles)) {
      return Promise.resolve();
    }

    return this.ticketService.uploadSterbeurkunde(
      this.sterbeurkundeFiles[0],
      this.ticket.id,
    );
  }

  get isDownloadSectionVisible() {
    // In case a bank uses their own request formular, we dont
    // need the download section since they upload their own
    // document.
    return !this.configSkipDownload;
  }

  get isSubmitSectionDirectBankVisible() {
    return (
      this.configSkipDownload ||
      this.warrantDownloaded ||
      this.isSubmitSectionVisible
    );
  }

  get isUploadSectionVisible() {
    // Since direct banks swap the template order of upload and submit,
    // we have to check for the skipGuidanceRequest flag at this point.
    if (this.isDirectBank && this.configSkipGuidanceRequest) {
      return false;
    }

    // skip for signoTec signment
    if (this.featureEnabledSignotecSignatureOrForceDefault) {
      return false;
    }

    return (
      this.configSkipDownload ||
      this.warrantDownloaded ||
      this.isSubmitSectionVisible
    );
  }

  get isSubmitSectionVisible() {
    if (this.isFeatureActive(this.FeatureNames.FF_DISABLE_VERIFYING_FINANCES)) {
      return false;
    }

    // For direct banks the submit section is visible as soon as the
    // initialization has been confirmed (warrant downloaded)
    if (this.isDirectBank && this.isInitializationConfirmed) {
      return true;
    }

    // By default the successful upload of the signed warrant is the indicator
    // to display the submit section of the warrant creation process.
    return (
      this.warrantUploaded ||
      this.selectedWarrantFile ||
      this.ticketService.hasStatus(
        this.ticket,
        this.TicketStates.WARRANT_SIGNED,
      )
    );
  }

  get isNextStepsDirectBankSectionVisible() {
    return (
      this.ticketService.hasStatus(
        this.ticket,
        this.TicketStates.INITIALIZATION_CONFIRMED_BY_USER,
      ) || this.initializationConfirmed
    );
  }

  get isPasswordRequired() {
    // this depends on submit section because an email address is required to set password.
    return this.isSubmitSectionVisible && this.showPasswordSection;
  }

  get isSubmitButtonVisible() {
    // The form button
    return !this.isDirectBank;
  }

  get isSubmitButtonDisabled() {
    if (this.isFeatureActive(this.FeatureNames.FF_DISABLE_VERIFYING_FINANCES)) {
      return !(
        (this.warrantUploaded &&
          this.ticketService.hasStatus(
            this.ticket,
            this.TicketStates.WARRANT_SIGNED,
          )) ||
        this.selectedWarrantFile
      );
    }
    return !this.isSubmitSectionVisible;
  }

  get isNachlass() {
    return (
      this.ticket && this.ticket.formValues && this.ticket.formValues.isNachlass
    );
  }

  get isInitializationConfirmed() {
    if (this.initializationConfirmed) {
      return true;
    }

    if (this.isDirectBank) {
      return this.ticketService.hasStatus(
        this.ticket,
        this.TicketStates.INITIALIZATION_CONFIRMED_BY_USER,
      );
    }
    return this.ticketService.hasStatus(
      this.ticket,
      this.TicketStates.INITIALIZATION_CONFIRMED,
    );
  }

  $onInit() {
    this.model = { selectedKwhType: null };
    this.breadcrumbs = this.receivingService.states;
    this.nextSteps = _.times(
      this.config.ui.customerEntry.numDetailSteps,
      String,
    );

    // prefill consultant mail if feature is activated
    if (this.prefilledConsultantEmail) {
      this.model.withoutGuidance = {
        bankEmployeeEmailAddress: this.prefilledConsultantEmail,
      };
    }

    // Status flags of the warrant current status
    this.warrantDownloaded = false;
    this.warrantUploaded =
      this.ticket &&
      this.ticket.status === TicketStatesReceiving.WARRANT_SIGNED;

    this.submitRequestForm = {};
    this.uploadAdditionalFiles = {};
    this.forceDefaultWarrantFlow = false;
    this.skipSignature = false;

    // Set all available kwh types if enabled by feature flag
    this.kwhTypes = _.pickBy(this.ReceivingKwhTypes, (value, key) => {
      return this.isFeatureActive(value);
    });

    // Set the preferred (= initial selected) kwh type
    // default is WITHOUT_GUIDANCE when it is available otherwise preselect first in list

    const firstKwhType = Object.keys(this.kwhTypes)[0];
    const maybeWithoutGuidence = _.find(
      this.kwhTypes,
      (key, value) => key === this.ReceivingKwhTypes.WITHOUT_GUIDANCE,
    );

    this.preferredKwhType = maybeWithoutGuidence || this.kwhTypes[firstKwhType];

    if (this.envService.getTenant().indexOf('fiducia') >= 0) {
      if (this.ticket.documents[0]) {
        this.docImageUrl = this.ticket.documents[0].url;
      }
    }

    this.requestSubmitItems = this.setRequestSubmitItems();

    this.handleKwhTypeChange(this.preferredKwhType);

    // Set max date for appointmentDate
    // TODO Get these date values from backend (because of the calculation of working days)
    const minDate = new Date();
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 9); // 7 + 2 (weekend)
    this.appointmentDateOptions = {
      minDate,
      maxDate,
    };

    // Need to set the languageOptions asynchronously
    this.setLanguageOptions().then(() => {
      angular.extend(this.appointmentDateOptions, this.languageOptions);
    });

    // Validation form messages
    this.formMessages = this.ValidationFormMessages;

    // Apply given guidance request data
    this.setGuidanceRequestFromTicket(this.ticket);

    this.initializePasswordSection();

    this.initializeSkipWarrantShipmentCheckbox();

    //hide the sidebar for users that entered via /customerEntry
    this.hideSidebar = this.userService.isCustomerEntryUser();

    if (this.featureEnabledSignotecSignatureOrForceDefault) {
      // not nice but for some reasons we do not get the signature from getter or watch-event
      this.signInterval = this.$interval((n, o) => {
        if (this.signoTecService.signatureImage) {
          this.signatureImage = this.signoTecService.signatureImage;
        }
      }, 10);
    }
  }

  initializePasswordSection() {
    if (!this.featurePasswordInSubmit) {
      return;
    }

    this.passwordForm = {};

    this.$scope.$watch(
      'vm.model',
      (model) => {
        if (
          model &&
          angular.isDefined(model.selectedKwhType) &&
          model[model.selectedKwhType] &&
          model[model.selectedKwhType].emailAddress
        ) {
          this.showPasswordSection = true;
          return;
        }
        this.showPasswordSection = false;
      },
      true,
    );
  }

  initializeSkipWarrantShipmentCheckbox() {
    if (this.skipWarrantShipmentToggleActive)
      this.$scope.$watch('vm.skipWarrantShipment', (skipWarrantShipment) => {
        if (skipWarrantShipment) {
          _.defaults(this.$scope, {
            confirmTitle: 'app.submitRequest.skipWarrantShipment.label',
            confirmBody: 'app.submitRequest.skipWarrantShipment.text',
            confirmOk: 'app.submitRequest.skipWarrantShipment.confirm',
          });

          this.needsConfirmationService.open({
            onDismiss: () => {
              this.skipWarrantShipment = false;
            },
            scope: this.$scope,
          });
        }
      });
  }
  setRequestSubmitItems() {
    const { ReceivingSubmitValidationRules, kwhTypes } = this;
    const tenant = this.envService.getTenant();
    const tenantGroup = this.envService.tenantGroup;
    let items = angular.copy(ReceivingSubmitValidationRules.default);

    // Overwrite default validation rules with tenant and tenantGroup (like SMM) specific rules
    let tenantItems = ReceivingSubmitValidationRules[tenant];
    let tenantGroupItems = ReceivingSubmitValidationRules[tenantGroup];

    if (tenantGroupItems) {
      _.forEach(items, (rules, key) => {
        if (tenantGroupItems[key]) {
          items[key] = tenantGroupItems[key];
        }
      });
    }

    if (tenantItems) {
      _.forEach(items, (rules, key) => {
        if (tenantItems[key]) {
          items[key] = tenantItems[key];
        }
      });
    }

    // Return only custom-specific and feature activated kwhType-items
    return _.pick(items, _.values(kwhTypes));
  }

  setGuidanceRequestFromTicket(ticket) {
    // Check for the configuration of the guidanceRequest
    if (this.configSkipGuidanceRequest) {
      return;
    }

    const { guidanceRequest } = ticket;
    if (guidanceRequest && guidanceRequest.type) {
      const { type, data } = guidanceRequest;
      if (type && data) {
        this.model[type.toLowerCase()] = data;
      }
    }
  }

  mapInfoBoxItems(item) {
    if (item === 'app.submitRequest.additional.info.first' && this.isNachlass)
      return 'app.submitRequest.additional.info.firstNachlass';
    return item;
  }

  getInfoBoxItems(category) {
    const { SubmitRequestInfoBoxItems } = this;
    const tenant = this.envService.getTenant();

    if (SubmitRequestInfoBoxItems[tenant]) {
      return SubmitRequestInfoBoxItems[tenant][category];
    }

    return SubmitRequestInfoBoxItems.default[category];
  }

  download(isGenerate) {
    let busyButton = isGenerate ? 'isGenerateBusy' : 'isDownloadBusy';
    return this.ticketService
      .redirectWarrantForm(this.ticket.id)
      .busy(this, busyButton)
      .then((res) => {
        this.docImageUrl = res.data.location;
        this.downloadCompleted();
      })
      .catch((err) => {
        this.warrantDownloaded = false;
      });
  }

  downloadCompleted() {
    this.warrantDownloaded = true;

    if (this.configSkipGuidanceRequest) {
      // Automatically confirm warrant by submitting without a guidance request
      this.confirmInitialization();
    }
  }

  skipDownload() {
    this.warrantDownloaded = true;
  }

  warrantFilePicked(file) {
    this.selectedWarrantFileName = file.name;
    this.selectedWarrantFile = file;
    return Promise.resolve(file);
  }

  uploadWarrant(file, force) {
    if (this.warrantUploaded) return Promise.resolve();
    let tenant = this.envService.getTenant();
    // vw and audi are special cases where the customer sends the warrant with a letter by himself
    if (tenant === 'volkswagenbank' || tenant === 'audibank')
      return Promise.resolve();
    if (this.isDirectBank) return Promise.resolve();

    return this.ticketService
      .uploadSignedWarrant(file, this.ticket.id, force)
      .busy(this, 'isUploadBusy')
      .then((resp) => {
        this.warrantUploaded = true;
        this.ticketService.load(this.ticket.id).then((result) => {
          this.ticket = result;
          const latestDocument = _.last(this.ticket.documents);
          this.filePreviewUrl = latestDocument && latestDocument.url;
        });
        return resp;
      })
      .catch((err) => {
        const { status, data } = err;
        if (status === 409) {
          this.go(this.ticketStateName, { ticketId: this.ticket.id });
          return err;
        }
        if (status === 417 && data.message === Errors.QRCODE_MISMATCH) {
          this.openQRMismatchModal(data);
        }

        this.warrantUploaded =
          this.ticket &&
          this.ticket.status === TicketStatesReceiving.WARRANT_SIGNED;
        return err;
      });
  }

  uploadAdditionalDocuments() {
    if (_.isEmpty(this.uploadAdditionalFiles)) {
      return Promise.resolve();
    }

    return this.ticketService
      .uploadAdditionalDocuments(this.ticket.id, this.uploadAdditionalFiles)
      .busy(this, 'isAdditionalUploadBusy');
  }

  closeRequest() {
    const { id, requestType } = this.ticket;
    this.ticketService.closeTicket(requestType, id).then((r) => {
      this.go(homeStateName);
    });
  }

  releaseTicketOverSidebar() {
    const { id, requestType } = this.ticket;
    return this.ticketService.releaseTicket(requestType, id).then(() => {
      this.go(homeStateName);
    });
  }

  handleKwhTypeChange(type) {
    this.model.selectedKwhType = type;

    const email = sessionStorage.getItem('emailAddressCustomer');

    if (email) {
      if (!this.model[type]) {
        this.model[type] = {};
      }
      this.model[type].emailAddress = email;
    }

    // Reset forms
    Object.keys(this.submitRequestForm).forEach((key) => {
      const form = this.submitRequestForm[key];
      form.$setUntouched();
      form.$setPristine();
    });
  }

  prepareModel() {
    const { model, skipWarrantShipment } = this;
    if (
      !model.selectedKwhType &&
      !this.isSubmitSectionVisible &&
      this.isFeatureActive(this.FeatureNames.FF_DISABLE_VERIFYING_FINANCES)
    ) {
      model.selectedKwhType = this.ReceivingKwhTypes.WITH_GUIDANCE;
    }

    if (
      !model.selectedKwhType &&
      !this.isSubmitSectionVisible &&
      this.isFeatureActive(this.FeatureNames.FF_DISABLE_VERIFYING_FINANCES)
    ) {
      model.selectedKwhType = this.ReceivingKwhTypes.WITH_GUIDANCE;
    }

    return {
      type: model.selectedKwhType,
      skipWarrantShipment: !!skipWarrantShipment,
      data: model[model.selectedKwhType] || null,
    };
  }

  submit(force = false) {
    this.uploadWarrant(this.selectedWarrantFile, force).then((r) => {
      // document too large
      if (r && r.status > 299) return;
      const data = this.prepareModel();

      if (
        !this.isSubmitSectionVisible &&
        this.isFeatureActive(this.FeatureNames.FF_DISABLE_VERIFYING_FINANCES)
      ) {
        return this.confirmInitialization(data);
      }

      let requestForm = this.submitRequestForm[this.model.selectedKwhType];
      requestForm.$submitted = true;
      if (requestForm && requestForm.$invalid) {
        return;
      }

      if (
        this.featurePasswordInSubmit &&
        this.isPasswordRequired &&
        this.passwordForm
      ) {
        this.passwordForm.$submitted = true;
        if (this.passwordForm.$invalid) {
          return;
        }
        data.data.password = this.passwordForm.password.$modelValue;
      }

      this.fdFormFieldsService.validate(requestForm).then(() => {
        this.uploadAdditionalDocuments().then(() => {
          this.uploadSterbeurkunde().then(() => {
            this.confirmInitialization(data);
          });
        });
      });
    });
  }

  confirmInitialization(data) {
    sessionStorage.removeItem('emailAddressCustomer');

    // Endpoint depends on customer and/or direct bank flow
    if (this.userService.isCustomerEntryUser() || this.isDirectBank) {
      return this.ticketService
        .initializationConfirmationByCustomer(this.ticket.id, data)
        .busy(this, 'submitBusy')
        .then(() => {
          // Activate success flag to show next steps
          this.initializationConfirmed = true;

          // Navigate to success state only when
          // this is not a direct bank.
          if (!this.isDirectBank) {
            this.goToSuccess();
          }
        });
    }

    return this.ticketService
      .initializationConfirmation(this.ticket.id, data)
      .busy(this, 'submitBusy')
      .then(() => this.goToSuccess());
  }

  sendSignatureForWarrant() {
    if (this.signatureImage) {
      const { id } = this.ticket;
      this.ticketService
        .getWarrantWithSignature(id, {
          signature: this.signatureImage,
          acceptSignatureUsageForSEPA: this.acceptSignatureUsageForSEPA,
        })
        .busy(this, 'busySignatureButton')
        .then((res) => {
          this.$interval.cancel(this.signInterval);
          this.ticketService
            .redirectWarrantForm(id, true)
            .busy(this, 'busySignatureButton')
            .then((res) => {
              // to show document in pdf-viewer
              this.docImageUrl = res.data.base64Location;
              this.warrantDownloaded = true;
              this.warrantUploaded = true;
              // refresh ticket
              this.ticketService.load(id).then((result) => {
                this.ticket = this.ticketReaderFactory.createForDetail(result);
              });
            });
        });
    }
  }

  forceQuitSignoTecSignature() {
    this.forceDefaultWarrantFlow = true;
  }

  skipSignoTecSignature() {
    this.skipSignature = true;
  }

  /**
   * Navigate to the success state of the newly created ticket.
   */
  goToSuccess() {
    this.$window.location.href = `/receiving/request/success/${this.ticket.id}`;
  }

  openQRMismatchModal(data) {
    this.qrMismatchService.openModal(data).result.then((res) => {
      this.submit(true);
    });
  }

  /**
   * Navigate to the ticket state of the newly created ticket.
   */
  goToTicket() {
    this.go(this.ticketStateName, { ticketId: this.ticket.id });
  }

  getTranslationKey(key, after) {
    if (after) {
      after = '.' + after;
    }

    return `app.submitRequest.${key}${after || ''}`;
  }

  isPreferredKwhType(kwhType) {
    return kwhType === this.preferredKwhType;
  }

  isKwhTypeSelected(kwhType) {
    return kwhType === this.model.selectedKwhType;
  }

  isFormFieldRequired(formfield, kwhType) {
    const { model } = this;
    const { required, requiredBy, requiredUnless, requiredByFeature } =
      formfield;

    if (required === true) {
      return true;
    }

    if (requiredByFeature) {
      return this.isFeatureActive(requiredByFeature);
    }

    const propertyExists = () => model[kwhType] && model[kwhType][requiredBy];
    if (requiredBy) {
      return propertyExists();
    }

    if (requiredUnless) {
      return !propertyExists();
    }

    return false;
  }

  showFormField(formfield, kwhType) {
    const { model } = this;
    const { hideWhen } = formfield;

    if (hideWhen) {
      return !(model[kwhType] && model[kwhType][hideWhen]);
    }

    return true;
  }
}
